import React from "react";
import { Row, Col, Form, Card } from "react-bootstrap";
import InputComponent from "../InputComponent/InputComponent";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import ColDynamic from "../../EntryForms/WrapperComponents/ColDynamic";
import "./ControlMeasureSearch.css";
import { Button } from "antd";

const ControlMeasureSearch = (props) => {
  return (
    <>
      <div className="mb-3">
        <Row className="row justify-content-center" key={"form"}>
          <Col lg={7} className="align-self-center">
            <Card className="search_card">
              <Card.Body>
                <Card.Title className="nolabel">
                  Pretraga subjekata nadzora
                </Card.Title>

                <Form onSubmit={props.onSubmit} id="form">
                  <Row className="nolabel">
                    <ColDynamic className="col-lg-4">
                      <InputComponent
                        className="search_component "
                        id="oib"
                        title="Oib"
                        value={props.oib}
                        onChange={props.userInputHandler}
                        placeholder={"OIB"}
                        // controlLabel={"OIB"}
                      />
                    </ColDynamic>
                    <ColDynamic className="col-lg-4">
                      <InputComponent
                        className="search_component"
                        id="regNumber"
                        title="Registarski broj"
                        value={props.regNumber}
                        onChange={props.userInputHandler}
                        placeholder={"Registarski broj"}
                      />
                    </ColDynamic>

                    <ColDynamic className="col-lg-4">
                      <InputComponent
                        className="search_component"
                        id="subjectName"
                        title="Naziv subjekta"
                        value={props.subjectName}
                        onChange={props.userInputHandler}
                        placeholder={"Naziv subjekta"}
                      />
                    </ColDynamic>
                  </Row>
                  <Row className="nolabel">
                    {/* </Row>
                <Row> */}
                    <ColDynamic className="col-lg-6">
                      <InputComponent
                        className="search_component"
                        id="nameSurname"
                        title="Ime"
                        value={props.nameSurname}
                        onChange={props.userInputHandler}
                        placeholder={"Ime"}
                      />
                    </ColDynamic>

                    <ColDynamic className="col-lg-6">
                      <InputComponent
                        className="search_component"
                        id="surName"
                        title="Prezime"
                        value={props.surName}
                        onChange={props.userInputHandler}
                        placeholder={"Prezime"}
                      />
                    </ColDynamic>
                  </Row>
                  <Row className="nolabel">
                    <ColDynamic className="col-lg-6">
                      <InputComponent
                        className="search_component"
                        id="class"
                        title="Klasa"
                        value={props.class}
                        onChange={props.userInputHandler}
                        placeholder={"Klasa"}
                      />
                    </ColDynamic>
                    <ColDynamic className="col-lg-6">
                      <InputComponent
                        className="search_component"
                        id="mbs"
                        title="Matični broj subjekta"
                        type="number"
                        min="0"
                        value={props.mbs}
                        onChange={props.userInputHandler}
                        placeholder={"MBS"}
                      />
                    </ColDynamic>
                  </Row>

                  <div className="row" key={"button"}>
                    <div className="col-md-4 ">
                      <ButtonComponent
                        className="primary_button"
                        variant="primary"
                        type="submit"
                        block={true}
                        disabled={props.isLoading === true}
                      >
                        Pretraga
                      </ButtonComponent>
                    </div>

                    <div className="col-md-4">
                      <ButtonComponent
                        block={true}
                        variant="danger"
                        onClick={props.clearSearch}
                      >
                        Odustani
                      </ButtonComponent>
                    </div>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ControlMeasureSearch;
